/**
 * BLU-659 — 3PL client-facing order-status dashboard.
 *
 * Backed by the `get_client_order_statuses(...)` Postgres RPC (migration
 * 20260718110000_client_order_status_rpc.sql). One row per Shopify order,
 * aggregated across the client's fulfillment-order rows (post-BLU-563
 * `prod_orders` is per-FO). Monotonic ladder:
 * New Order -> Picking -> Printed -> Ready To Pack -> Shipped.
 *
 * BLU-834: `cancelled` is a TERMINAL state OFF that ladder, not a sixth rung.
 * It requires no live fulfilment orders plus at least one genuinely cancelled
 * FO (`cancelled_at` is set by the Shopify/customer source), so edit-removal,
 * Mini Zali drain, and internal status-override rows do not masquerade as
 * customer cancellations.
 * It is listed last so the filter chips
 * render the ladder in order with the terminal state at the end.
 */
export const CLIENT_ORDER_STATUSES = [
    'new_order',
    'picking',
    'printed',
    'ready_to_pack',
    'shipped',
    'cancelled',
];
